// extracted by mini-css-extract-plugin
export var columnList = "_ay-0";